import { UnreachableError } from 'base/helpers';
import {
  ServerMessage,
  ServerPresenceJoinMessage,
} from 'blocks/blocks_service';
import { computed, makeObservable, observable } from 'mobx';

export class PresenceTracker {
  sessionsById = observable.map<number, ServerPresenceJoinMessage>([], {
    deep: false,
  });
  @observable.ref
  mySessionId: number | undefined = undefined;

  constructor() {
    makeObservable(this);
  }

  @computed
  get sessions() {
    return Array.from(this.sessionsById.values());
  }

  @computed
  get mySession() {
    return this.mySessionId
      ? this.sessionsById.get(this.mySessionId)
      : undefined;
  }

  handleMessage(
    msg: ServerMessage & { type: 'presenceJoin' | 'presenceLeave' | 'init' },
  ) {
    switch (msg.type) {
      case 'init':
        this.mySessionId = msg.sessionId;
        this.sessionsById.clear();
        for (const inner of msg.initialPresenceJoins) {
          this.sessionsById.set(inner.sessionId, inner);
        }
        break;
      case 'presenceJoin':
        this.sessionsById.set(msg.sessionId, msg);
        break;
      case 'presenceLeave':
        this.sessionsById.delete(msg.sessionId);
        break;
      default:
        throw new UnreachableError(msg);
    }
  }
}
